import './Rating.scss'
import star from '../../assets/img/star.png'
import { FC } from 'react';

interface RatingProps {
    rating: number
    ratingClass?: string
    spanClass?: string
    starClass?: string
}


export const Rating: FC<RatingProps> = ({ rating, ratingClass = 'rating', starClass = 'rating__star', spanClass = 'rating__number' }) => {

    const getRatingTwoSings = () => {
        return rating ? rating.toFixed(1) : '0.0'; // Форматируем рейтинг
    };

    /* let ratingClass = 'rating';
 */
    if (rating >= 8) {
        ratingClass += ' rating__high';
    } else if (rating > 6) {
        ratingClass += ' rating__medium';
    } else if (rating > 4) {
        ratingClass += ' rating__low';
    }

    return (
        <div className={ratingClass}>
            <img className={starClass} src={star} alt="star" />
            <span className={spanClass}>{getRatingTwoSings()}</span>
        </div>
    );
};
